import { assignModelField } from '@/common/helpers/assignModel';
import { ContactData, ContactDataModel } from '@/contacts/entity/ContactData';

export class ContactDataLinkModel {
  id!: string;
  contactData!: ContactDataModel;
}

export class ContactDataLink extends ContactDataLinkModel {
  constructor(modelData: ContactDataLinkModel) {
    super();

    Object.keys(modelData).forEach((key) => {
      switch (key) {
        case 'contactData':
          this.contactData = new ContactData(modelData.contactData);

          break;
        default:
          assignModelField<ContactDataLinkModel>(this, modelData, key);

          break;
      }
    });
  }
}
